/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Popper, Fade, Paper, Typography, Divider, IconButton, Tooltip, List, ListItem, ListItemText, ListItemSecondaryAction, ClickAwayListener } from '@material-ui/core'
import { Refresh, Add, ArrowRight } from '@material-ui/icons'

import Actions from '../../../../../../fluid/Actions/ActionFactory'
import CreateEventGroup from '../../../../../Events/components/CreateEventGroup'

import EventList from './EventList'

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      // primary: {
      //     main: "#FF6600",
      //     contrastText: "#FFFFFFFF"
      // },
      secondary: {
        main: "#dc004e",
      },
    },
});

const styles = theme => ({

})

class EventGroupList extends Component {
    state = {
        event_groups : null,
        getting_groups : false,
        event_groups_err : false,
        event_anchor_el : null,
        selected_event_group : null,
        add_group : false,
        openPopper: true
    }

    componentDidMount () {
        this.getEventGroups()
    }

    getEventGroups = () => {
        this.setState({
            ...this.state,
            getting_groups : true,
            event_anchor_el : null,
            selected_event_group : null
        }, () => {
            Actions('http_request', {
                url : "/sainapse/event_group/",
                method : "get",
                data : {}
            }).then(res => {
                this.setState({
                    ...this.state,
                    event_groups : res.data.result,
                    getting_groups : false,
                    event_groups_err : false,
                    //openPopper : Boolean(this.props.anchorEl)
                })
            }).catch(err => {
                this.setState({
                    ...this.state,
                    event_groups : null,
                    getting_groups : false,
                    event_groups_err : true
                })
            })
        })
    }

    renderEventGroupListBox = () => {
        if (this.state.getting_groups) {
            return (
                <div style = {{width : '100%', height : '100%', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <Typography color = 'textSecondary'><em>Getting Event Groups...</em></Typography>
                </div>
            )
        } else {
            if (this.state.event_groups !== null) {
                if (this.state.event_groups.length === 0) {
                    return (
                        <div style = {{width : '100%', height : '100%', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                            <Typography color = 'textSecondary'><em>No Event Groups Registered.</em></Typography>
                        </div>
                    )
                } else {
                    return (
                        <List>
                            {this.renderEventGroupList()}
                        </List>
                    )
                }
            } else {
                if (this.state.event_groups_err) {
                    return (
                        <div style = {{width : '100%', height : '100%', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                            <Typography variant = 'caption' color = 'secondary'><em>Error retreiving Event Groups.</em></Typography>
                        </div>
                    )
                }
            }
        }
    }

    renderEventGroupList = () => {
        
        let event_groups = this.state.event_groups.filter(event_group => event_group.name !== "root").map((event_group, i) => {
            return (
                <ListItem 
                    key = {i} 
                    dense 
                    button 
                    selected = {this.state.selected_event_group === event_group.name}
                    onClick = {(event) => this.selectEvent(event, event_group.name)}
                >
                    <ListItemText  primary = {event_group.name}/>
                    <ListItemSecondaryAction>
                        <ArrowRight style = {{color : 'rgba(0,0,0,0.5)'}} fontSize = 'small'/>
                    </ListItemSecondaryAction>
                </ListItem>
            )
        })

        return event_groups
    }

    selectEvent = (event, event_group_name) => {
        this.setState({
            ...this.state,
            event_anchor_el : event.currentTarget,
            selected_event_group : event_group_name
        })
    }

    renderEventList = () => {
        if (this.state.event_anchor_el !== null) {
            console.log("Event Anchor : ", this.state.event_anchor_el)
            return (
                <EventList 
                    key = {this.state.selected_event_group} 
                    anchorEl = {this.state.event_anchor_el} 
                    event_group_name = {this.state.selected_event_group}
                    push_event = {(event_name) => this.props.push_event(event_name)}
                />
            )
        }
    }

    openDialog = () => {
        this.setState({ ...this.state, openPopper: false }, () => {
            this.setState({
                ...this.state,
                add_group : true
            })
        })
        
    }

    closeDialog = (field) => {
        this.setState({...this.state,
            [field] : false
        })
    }

    renderCreateEventGroup = () => {
        if (this.state.add_group) {
            return (
                <CreateEventGroup zIndex = "20" open = {this.state.add_group} close = {() => this.closeDialog("add_group")}/>
            )
        }
    }

    handleClickAway = () => {
        this.setState({ openPopper: false })
    }

    render() {
        const { classes } = this.props
        return (
            <ThemeProvider theme = {blue_theme}>
                
                <Popper
                    style = {{zIndex : "9999"}}
                    id = "event-list" 
                    open = {this.state.openPopper} 
                    anchorEl={this.props.anchorEl} 
                    transition
                    placement="bottom-end"
                    //disablePortal={false}
                    modifiers={{
                        flip: {
                            enabled: true,
                        },
                        preventOverflow: {
                            enabled: true,
                            boundariesElement: 'scrollParent',
                        },
                        // arrow: {
                        //     enabled: false,
                        //     element: arrowRef,
                        // },
                    }}
                >
                    {({TransitionProps}) => (
                        <ClickAwayListener onClickAway={  this.handleClickAway }  >
                            <Fade {...TransitionProps} timeout={350}>
                                <Paper elevation = {5} style = {{width : '300px', height : '300px', display : 'flex', flexDirection : 'column'}}>
                                    <div style = {{padding : '10px', display : 'flex', flexDirection : 'row', borderBottom : '1px solid rgba(0,0,0,0.12)', alignItems : 'center'}}>
                                        <Typography style = {{flexGrow : 1}} variant = 'subtitle2' color = 'textSecondary'>Event Groups</Typography>
                                        <Tooltip PopperProps = {{style : {zIndex : '10000'}}} title = "Add Event Group">
                                            <IconButton style = {{marginRight : '5px'}} size = 'small' color = 'primary' onClick = {this.openDialog}>
                                                <Add fontSize = 'small'/>
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip PopperProps = {{style : {zIndex : '10000'}}} title = "Refresh">
                                            <IconButton size = 'small' color = 'primary' onClick = {this.getEventGroups}>
                                                <Refresh fontSize = 'small'/>
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                    <div style = {{flexGrow : 1, overflow: 'auto'}}>
                                        {this.renderEventGroupListBox()}
                                    </div>
                                </Paper>    
                            </Fade>
                        </ClickAwayListener>
                    )}
                </Popper>
               
                {this.renderEventList()}
                {this.renderCreateEventGroup()}
            </ThemeProvider>
        );
    }
}

export default withStyles(styles)(EventGroupList);